import { MutableRefObject } from 'react';

import {
    scrollTo,
    addTextareaInvalidClass,
    removeTextareaInvalidClass,
} from '../../utils';

function setFieldAsInvalid(
    field: MutableRefObject<HTMLInputElement>,
    label: MutableRefObject<HTMLElement>,
) {
    if (field.current.value) {
        removeTextareaInvalidClass(field);
        return;
    }

    addTextareaInvalidClass(field);
    scrollTo(label.current);
}

export function checkFieldsValidation(
    fields: MutableRefObject<HTMLInputElement>[],
    labels: MutableRefObject<HTMLElement>[],
) {
    fields.forEach((field, index) => setFieldAsInvalid(field, labels[index]));
}

export function checkFieldsAreNotEmpty(
    fields: MutableRefObject<HTMLInputElement>[],
) {
    return fields.every(field => field.current.value);
}
